export default "__VITE_ASSET__pegrw06c__"